<template>
    <div :class="{ flex: !toggler.isOpen() }">
        <div>電子信箱</div>
        <div>
            <div class="editable" v-if="!toggler.isOpen()">
                <span v-if="props.value">{{ props.value }}</span>
                <span class="no-data color:#333333" v-else>尚未確認</span>
                <button @click="open" type="button">
                    <img alt="" class="w:20 h:20" src="image/icon_pen.svg" />
                </button>
            </div>
            <div class="{mt:8}@<md" v-else>
                <div class="input-group rel w:full">
                    <input class="form-control" :class="{ error: mail.error }" @input="mail.error = false" inputmode="email" placeholder="請輸入電子信箱" ref="input" type="text" v-model.trim="mail.target" />
                    <button class="btn btn-secondary w:120 opacity-50 fw-bold" type="button" v-if="mail.countdown">{{ toTimeString(mail.countdown) }}</button>
                    <button class="btn btn-secondary w:120" :class="{ 'btn-danger': mail.error }" @click="send" type="button" v-else-if="mail.target">傳送驗證碼</button>
                </div>
                <div class="row mt:8! max-w:368" v-if="mail.pending">
                    <div class="col-12">
                        <div class="input-group">
                            <input class="form-control" :class="{ error: mail.code_error }" id="member-mail-code" @input="mail.code_error = false" inputmode="numeric" placeholder="請輸入驗證碼5碼" type="text" v-model.trim="mail.code" />
                            <button class="btn btn-secondary w:120" :class="{ 'btn-danger': mail.code_error }" @click="verify()" type="button" v-text="mail.code_error ? '驗證碼有誤' : '點我驗證'"></button>
                        </div>
                    </div>
                </div>
                <div class="mt:8">
                    <div class="info-msg">不接受學校信箱</div>
                </div>
                <div class="t:right mt:8 {ml:8}>button+button">
                    <button class="btn btn-sm bg:#EEF3FB! color:#4776B4!" @click="toggler.close()" type="button">關閉</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    let submited = false;

    const input = ref({});

    const mail = ref({});

    const props = defineProps({
        value: { required: true, type: String }
    });

    const toggler = ToggleStore().toggler("profile_email");

    const emit = defineEmits(["error", "login", "send", "update"]);

    const open = () => {
        mail.value = { code: "", code_error: false, countdown: 0, error: false, input: "#member-mail-code", pending: false, target: "", url: "api/member/mail/send-code" };
        toggler.open();
        setTimeout(() => input.value.focus());
    };

    const send = () => {
        emit("send", mail.value);
    };

    const toTimeString = (time) => {
        const m = parseInt(time / 60);
        const s = time % 60;
        return (100 + m).toString().substring(1) + ":" + (100 + s).toString().substring(1);
    };

    const verify = (password) => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/mail/verify", { code: mail.value.code, password }, { prevent: true }).done((res) => {
            if (res.success) {
                emit("update", mail.value.target);
                toggler.close();
            } else {
                switch (res.error) {
                    case "error.permission-denied":
                        emit("login", verify);
                        break;
                    case "error.verification-code-not-matched":
                        mail.value.code_error = true;
                        break;
                    default:
                        emit("error", res.message);
                }
            }
        }).always(() => {
            submited = false;
        });
    };
</script>
